<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="alert-octagon"
    [title]="'Результаты рассылки: ' + resultsKeys.length"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="container-fluid">
        <table>
          <tbody>
          <tr>
            <td class="text-muted" colspan="2">
              Если в результате только ID сообщения - отправлено успешно, но ссылку получить на сообщение не удалось, возможно
              чат
              закрыт.
            </td>
          </tr>
          <ng-template ngFor let-i="index" let-c="count" let-key [ngForOf]="resultsKeys">
            <tr *ngIf="contactsResult[key] as item">
              <td>
                <div [innerHTML]="key | href" class="text-eclipse text-dark"></div>
              </td>
              <td>
                <div class="">
                  <a [href]="item['link']" target="_blank" *ngIf="item.link; else defaultLabel"
                     class="badge badge-{{color(item)}}">
                    {{item['link']}}
                  </a>
                  <ng-template #defaultLabel>
                <span class="badge badge-{{color(item)}}">
                  {{item?.status}}
                </span>
                  </ng-template>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
